export default "__VITE_ASSET__1d577c4a__"